
import Vue from 'vue';
import {
  AccountWithID,
  CustomerReportSchedule,
} from '@/store';

interface ScheduleVMMixin extends CustomerReportSchedule {
  addingAccount: false|undefined|number;
  showEmails: boolean;
}

export default Vue.extend({
  name: 'CustomerReportSchedule',
  data: () => ({
    accounts: [] as AccountWithID[],
    accountsMap: {} as {[id: number]: AccountWithID},
    schedules: [] as ScheduleVMMixin[],
  }),
  async mounted() {
    this.accounts = await this.$store.dispatch('accounts/includeNonLive');
    this.accounts.sort((a, b) => a.account_code.localeCompare(b.account_code));
    this.accounts.forEach((a) => {
      this.accountsMap[a.account_id] = a;
    });
    const schedules: CustomerReportSchedule[] = await this.$store.dispatch('customerReportSchedules/list');
    this.schedules = schedules.map((s) => ({
      ...s,
      addingAccount: false,
      showEmails: false,
    }));
    this.schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
  },
  methods: {
    removeAccount(schedule: CustomerReportSchedule, accountID: number) {
      schedule.accounts = schedule.accounts.filter((a) => a !== accountID);
    },
    async save(schedule: CustomerReportSchedule) {
      await this.$store.dispatch('customerReportSchedules/save', schedule);
    },
    addCustomer() {
      this.schedules.push({
        id: undefined,
        // eslint-disable-next-line @typescript-eslint/camelcase
        customer_name: '',
        morning: false,
        midday: false,
        eod: true,
        // eslint-disable-next-line @typescript-eslint/camelcase
        include_monthly_progress: false,
        accounts: [],
        // eslint-disable-next-line @typescript-eslint/camelcase
        email_recipients: [],
        addingAccount: false,
        showEmails: false,
      });
    },
    async update(schedule: CustomerReportSchedule) {
      await this.$store.dispatch('customerReportSchedules/update', schedule);
    },
    async download(schedule: CustomerReportSchedule) {
      const response = await this.$store.dispatch('customerReportSchedules/download', schedule);
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${schedule.customer_name} Performance Report.xlsx`;
      const body = document.querySelector('body');
      if (!body) {
        // Can't happen
        return;
      }
      body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    },
  },
});
